<template lang="pug">
  .add-wa-form
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.px-4.h6.basic800--text {{ $t('sort_products') }}
        v-divider.basic300
        v-card-text.px-0.pb-0
          div.mt-3
            div.c1.mb-2.primary400--text.px-4 {{ $t('drag_and_drop') }}
              ArrowsSortIcon.mx-1.mb-n1(size="16" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
              | {{ $t('icon_to_rearrange') }}
            draggable(tag="div" :list="products" handle=".handle" @start="drag=true"  @end="drag=false")
              template(v-for="(element, idx) in products")
                v-card.my-1(flat :class="{ 'drag-active': drag }" style="border-bottom:1px solid var(--v-basic300); border-radius:0")
                  v-list-item.px-4
                    v-list-item-action.my-0.mr-3
                      template(v-if="element.image")
                        v-img.my-2(:src="element.image.file" width="50px" height="50px")
                          v-avatar.caption(color="grey lighten-2" size="20") {{ idx + 1 }}
                          template(v-slot:placeholder)
                            v-row(class="fill-height ma-0" align="center" justify="center")
                              v-progress-circular(indeterminate color="grey")
                      template(v-else)
                        v-avatar.caption(color="grey lighten-2" size="20") {{ idx + 1 }}
                    v-list-item-content {{ element.name }}
                    v-list-item-icon.my-auto.ml-1.handle(:class="{ 'drag-inactive': !drag }")
                      v-icon(size="26") mdi-swap-vertical-bold
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32 :loading="isLoading" @click="clickSave" dark)
            .button-AA-small.basic100--text {{ $t('save') }}

</template>

<script>
import { mapActions } from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'SortProduct',
  props: ['open', 'company', 'form'],
  components: { draggable },
  data: () => ({
    products: [],
    isLoading: false,
    drag: false
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    currentForm: {
      get() {
        return this.form
      },
      set(newValue) {
        this.$emit('update:form', newValue)
      }
    },
  },
  watch: {
    showModal: {
      immediate: true,
      handler (val) {
        if (val) {
          this.products = [...this.form.products]
        }
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      this.isLoading = true
      let data = {
        products: this.products.map(m => { return m.id })
      }
      this.axios.patch(`/forms/${this.form.id}/`, data)
        .then(resp => {
          this.currentForm = resp.data
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
}
</script>

<style scoped>
.drag-inactive { cursor: grab; }
.drag-active { cursor: grabbing; }
.handle {
  /* float: left; */
  padding: 8px 0 8px 8px;
}
</style>

<i18n>
{
  "en": {
    "sort_products": "Sort Products",
    "drag_and_drop": "Drag and drop the",
    "icon_to_rearrange": "icon to rearrange the products"
  },
  "id": {
     "sort_products": "Urutkan Produk",
    "drag_and_drop": "Tarik dan letakkan",
    "icon_to_rearrange": "ikon untuk mengurutkan kategori"
  }
}
</i18n>